import { useMutation, useQueryClient } from '@tanstack/react-query'
import React from 'react'
import toast from 'react-hot-toast';
import { generateReport as generateReportAPI, generateReportReviewed} from 'services/apiReport';

const useGenerateFinalReport = () => {
  const queryClient = useQueryClient();
  const {isPending: isGenerating, isSuccess: isGenerated, mutate: generateReport,data} = useMutation({
    mutationFn: ({orderId,productType})=>{
      if(productType === 'DA-Reviewed'){
        return generateReportReviewed(orderId);
      }

      return generateReportAPI(orderId)
    },
    onSuccess:(data)=>{
        toast.success("Report Generated Sucessfully")
    },
    onError:(error)=>{
        toast.error(error?.data?.message || "An error occurred while generating the final report")
        console.error("Error occurred:",error)
    }
  })

  return{isGenerating, isGenerated,generateReport,data}
}

export default useGenerateFinalReport